<button
  class="sharry-simple"
  [class.no-cursor-pointer]="disabled"
  (click)="onReport()">
  <sharry-icon
    svgClass="svg-icon default-circle-radius"
    [name]="icon"
    [type]="iconType"></sharry-icon>
  {{ (title ? title : isTitle ? (isCreate ? 'report.create-title' : 'report.title') : '') | i18next }}
</button>
